import Link from './Link';
import { dollarFormat } from '../../numeral';
import styles from '../../../sass/status.module.scss';
export default (function (_ref) {
  var _ref$examRegistration = _ref.examRegistrations,
      examRegistrations = _ref$examRegistration === void 0 ? {} : _ref$examRegistration,
      _ref$cost = _ref.cost,
      cost = _ref$cost === void 0 ? {} : _ref$cost,
      _ref$studentRegistrat = _ref.studentRegistrations,
      studentRegistrations = _ref$studentRegistrat === void 0 ? {} : _ref$studentRegistrat,
      _ref$school = _ref.school,
      school = _ref$school === void 0 ? {} : _ref$school,
      hideOrderPanel = _ref.hideOrderPanel,
      hideStudentRegistrations = _ref.hideStudentRegistrations,
      history = _ref.history;
  var numberStudentsEnrolled = studentRegistrations.numberStudentsEnrolled,
      numberEnrollments = studentRegistrations.numberEnrollments;
  var numberUndecided = examRegistrations.numberUndecided,
      standardExamDecisionDeadline = examRegistrations.standardExamDecisionDeadline,
      orderStatus = examRegistrations.orderStatus,
      changeOrderStatus = examRegistrations.changeOrderStatus,
      numberTakingExam = examRegistrations.numberTakingExam;
  var hasUnsubmittedChanges = changeOrderStatus === 'NOT_SUBMITTED';
  var isSubmitted = orderStatus === 'SUBMITTED';
  var totalCost = cost.totalCost;
  var allowedToOrder = school.allowedToOrder;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['status-list']
  }, !hideStudentRegistrations ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Enrolled"), /*#__PURE__*/React.createElement("strong", null, numberStudentsEnrolled, " | ", numberEnrollments)) : null, standardExamDecisionDeadline ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Undecided"), /*#__PURE__*/React.createElement("strong", null, numberUndecided)) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Total Cost"), /*#__PURE__*/React.createElement("strong", null, dollarFormat(totalCost))), !hideOrderPanel ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Order"), /*#__PURE__*/React.createElement("strong", null, !isSubmitted ? 'Not Submitted' : hasUnsubmittedChanges ? 'Unsubmitted Changes' : 'Submitted')) : null, !hideOrderPanel ? hasUnsubmittedChanges || !isSubmitted ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/orders",
    className: "".concat(!numberTakingExam || !allowedToOrder ? 'disabled' : '', " btn btn-sm btn-primary")
  }, "Review & Submit")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/orders/history"
  }, "View Order Details ", /*#__PURE__*/React.createElement("i", {
    className: "cb-glyph cb-east",
    "aria-hidden": true
  }))) : null);
});